export default __webpack_public_path__ + "static/media/language-translation.8edb352910e524135a1fadf0d7d6c9e2.svg";